// 支付路由
const trendData = {
    path: 'trend',
    component: () => import('@/components/RouterView'),
    meta: {title: '趋势数据'},
    redirect: '/manage/trend/song',
    children: [
        {
            path: 'song',
            component: () => import('@/views/manage/trend/song'),
            meta: {title: '趋势数据'},
        },
        {
            path: 'artist',
            component: () => import('@/views/manage/trend/artist'),
            meta: {title: '趋势数据'},
        },
        {
            path: 'region',
            component: () => import('@/views/manage/trend/region'),
            meta: {title: '趋势数据'},
        },
    ],
};

export default trendData;
